import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useTranslateContext } from "../../contexts/translate.context";
import CondominiumHeader from "../headers/condominium.header";
import ResidentCondominiumForm from "./forms/resident.condominium.form";
import ResidentCondominiumList from "./lists/resident.condominium.list";
import EstateAllCondominiumForm from "./forms/estate-all-condominium-form";

export interface IResidentCondominiumProps {
    viewOnly?: boolean
}

export const ResidentCondominium: React.FC<IResidentCondominiumProps> = (props: IResidentCondominiumProps) => {

    const { estateId } = useParams();
    const location = useLocation();

    const { display } = useTranslateContext();

    const title = display.title.resident;
    const description = '';

    let reloadPage = false;
    const [ isLoading, setLoading ] = useState(false);
    const [ recordSelected, setRecordSelected ] = useState({ param : estateId || '', selected : ((estateId === 'new') || (estateId === '0') || (!Number.isNaN(Number.parseInt(estateId ||'')))) });

    function setSelected(isRecord: boolean, recordId: string) {
        setRecordSelected({ param : recordId, selected : isRecord });
    }

    async function initialize() {
    }
    
    useEffect(() => {
        if (!isLoading && !reloadPage) {
            initialize();
            setLoading(true);
        }

        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            reloadPage = !reloadPage;
        }
    }, []);
    
    return (
        <div className="page">
            {(recordSelected.selected) ? (
                <EstateAllCondominiumForm
                    title={`${display.title.estate} - ${title}`} 
                    identifier={recordSelected.param}
                    viewOnly={props.viewOnly}
                    tabView={'estate-resident'}
                    setRecord={(event: any, recordId: string) => { 
                        event.preventDefault();
                        setSelected(false, recordId); 
                    }}
                />
            ) : (
                <>
                <CondominiumHeader title={title} description={description} />
                <ResidentCondominiumList
                    title={title}
                    setRecord={(event: any, recordId: string) => { 
                        event.preventDefault();
                        setSelected(true, recordId); 
                    }}
                    viewOnly={props.viewOnly}
                />
                </>
            )}
        </div>
    )
}

export default ResidentCondominium;
